import {useSessionStore} from '../store';

export const getAuthorizationHeader = () => {
	return {
		Authorization: useSessionStore.getState().isToken
			? `shareToken ${useSessionStore.getState().key}`
			: `sessionKey ${useSessionStore.getState().key}`,
	};
};

export default getAuthorizationHeader;
